(() => {
  const styleId = 'np-port8-compact-style';
  const mobileQuery = window.matchMedia('(max-width: 767px)');
  const css = `
    .port8-widget__tooltip {
      display: none !important;
    }

    .port8-widget__button,
    .port8-widget__button--mobile {
      width: 142px !important;
      height: 48px !important;
      min-width: 142px !important;
      border-radius: 999px !important;
      padding: 0 14px !important;
      justify-content: flex-start !important;
      gap: 9px !important;
      box-sizing: border-box !important;
      background: #F7F3ED !important;
      border: 1px solid #111111 !important;
      box-shadow: 0 3px 10px rgba(0, 0, 0, 0.10) !important;
      animation: none !important;
    }

    .port8-widget__button::after {
      content: 'התאמה וייעוץ';
      color: #111111;
      font-family: inherit;
      font-size: 13px;
      font-weight: 500;
      line-height: 1;
      white-space: nowrap;
      direction: rtl;
    }

    .port8-widget__button-icon {
      width: 25px !important;
      height: 25px !important;
      flex: 0 0 25px !important;
      filter: none !important;
    }

    :host(.np-hide-for-cart) .port8-widget__button,
    :host(.np-hide-for-cart) .port8-widget__button--mobile {
      display: none !important;
    }

    @media (max-width: 767px) {
      .port8-widget__button,
      .port8-widget__button--mobile {
        bottom: 64px !important;
        width: 132px !important;
        min-width: 132px !important;
        height: 44px !important;
        padding: 0 12px !important;
        gap: 7px !important;
      }

      .port8-widget__button::after {
        font-size: 12px;
      }

      .port8-widget__button-icon {
        width: 23px !important;
        height: 23px !important;
        flex-basis: 23px !important;
      }
    }
  `;

  function syncCartState() {
    const cartDrawer = document.getElementById('CartDrawer');
    const cartIsOpen = Boolean(mobileQuery.matches && cartDrawer && cartDrawer.classList.contains('is-active'));
    const host = document.getElementById('port8-widget-host');

    document.body.classList.toggle('np-cart-drawer-open', cartIsOpen);
    if (host) host.classList.toggle('np-hide-for-cart', cartIsOpen);
  }

  function applyCompactStyle() {
    const host = document.getElementById('port8-widget-host');
    const root = host && host.shadowRoot;

    if (!root) return false;

    if (!root.getElementById(styleId)) {
      const style = document.createElement('style');
      style.id = styleId;
      style.textContent = css;
      root.appendChild(style);
    }

    syncCartState();
    return true;
  }

  const pageObserver = new MutationObserver(() => {
    applyCompactStyle();
    syncCartState();
  });

  pageObserver.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class']
  });

  mobileQuery.addEventListener('change', syncCartState);
  applyCompactStyle();
  syncCartState();
})();
